import areas from "./areas.png";
import general from "./general.png";
import internal from "./internal.png";
import trafficLight from "./trafficLight.png";

import users from "./users.png";
import project from "./project.png";
import projectred from "./projectred.png";

import projectSize from "./projectSize.png";
import projectHours from "./projectHours.png";

export const menuIcons = {
	users,
	areas,
	project,
    projectred,
	general,
	internal,
	projectSize,
	projectHours,
	trafficLight,
};
